import React, { forwardRef } from 'react';
import clsx from 'clsx';

import styles from './Menu.module.scss';
import { StandardProps } from '../../types/common';

interface MenuItemProps extends StandardProps {
  /**
   * Determines whether the item is active
   */
  active?: boolean;
}

export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>(
  ({ children, className, active, ...props }, ref) => {
    return (
      <li
        {...props}
        ref={ref}
        className={clsx(styles['hds-menu__dropdown-item'], className, {
          active,
        })}
      >
        {children}
      </li>
    );
  }
);
